import $ from 'jquery';
import Actions from '@ppcp/actions';

const actions = new Actions();

actions.addAction('payment_element_ready', (controller) => {
    const gateway = controller.gateway;
    $(`#wfacp_smart_button_${gateway.id}`).show();
});

actions.addAction('payment_unavailable', controller => {
    const gateway = controller.gateway;
    $(`#wfacp_smart_button_${gateway.id}`).hide();
});

actions.addAction('updated_checkout', () => {
    const timeout = parseInt(wfacp_frontend.smart_button_hide_timeout || 100) + 50;
    setTimeout(() => {
        const count = $('.wfacp_smart_button_container').filter(':visible').length;
        $('.wfacp_smart_button_outer_buttons').attr('count', Math.min(count, 3));
    }, timeout);
});
